import React, { useState, useRef, useEffect } from 'react'
import Page1 from '../assets/Page1.jpg'
import Input from '../components/Input'
import Dropdown from '../components/Dropdown'
import { getUrlParams, randomString, reverseDateString } from '../common'
import MyDropzone from '../components/MyDropzone'
import Checkbox from '../components/Checkbox'
import SignatureCanvas from 'react-signature-canvas'
import axios from 'axios'
import { format, isAfter, isBefore } from 'date-fns'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import { clearPageMessage, showLoadingMessage, showSuccessMessage, showWarningMessage } from '../successMessage'
import MyCalendar from '../components/Calendar'
import Radio from '../components/Radio'
import { trainers } from '../constants'
import AddressSearch from '../components/AddressSearch'
import StudentDetailConfirmationModal from '../components/StudentDetailConfirmationModal'
import { pilotAttach, pilotRequest, pilotSubmission, pilotEnrolmentId, pilotFunctionUrl } from '../bookingPilotClient'
import {
    buildStudentDetailFieldValues,
    buildStudentDetailVerificationAudit,
    buildStudentDetailVerificationSnapshot,
    createStudentDetailVerificationState,
} from '../studentDetailVerification'

const Home = () => {

    const [page, setPage] = useState(0)
    const [errors, setErrors] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [showDetailConfirmationModal, setShowDetailConfirmationModal] = useState(false)
    const [detailConfirmationState, setDetailConfirmationState] = useState(createStudentDetailVerificationState())
    const [detailConfirmationSnapshot, setDetailConfirmationSnapshot] = useState('')


    // Page = 0
    const [studentName, setStudentName] = useState('')
    const [trainingCourse, setTrainingCourse] = useState('CPCWHS1001 Prepare to Work Safely in the Construction Industry')
    const [dateFirstPage, setDateFirstPage] = useState(new Date())
    const [trainerName, setTrainerName] = useState('') //Optional.

    const [iCan, setICan] = useState(['', '', '', '', '', '', '', '', '', '', ''])
    const iCanLabels = [
        'Write a SMS message',
        'Check change when shopping',
        'Read a TV guide',
        'Read an email',
        'Read a map',
        'Write a job application',
        'Calculate fractions, decimals and percentages',
        'Write a work report',
        'Read the prompts on an ATM',
        'Use a calculator',
        'Read an account or bill',
    ]


    const eoiOptions = ['100 Points Identity', 'Special Arrangements']
    const [alphabetWords, setAlphabetWords] = useState(['', '', '', '', '', ''])

    const [alphabetWordOne, setAlphabetWordOne] = useState('')
    const [alphabetWordTwo, setAlphabetWordTwo] = useState('')
    const [alphabetWordThree, setAlphabetWordThree] = useState('')
    const [alphabetWordFour, setAlphabetWordFour] = useState('')
    const [alphabetWordFive, setAlphabetWordFive] = useState('')
    const [alphabetWordSix, setAlphabetWordSix] = useState('')

    const incorrectWords = ['Mondey', 'Bus', 'Pensil', 'Shoes', 'Food', 'Phone', 'Cleen', 'House', 'Play', 'Tecnical']
    const [chosenIncorrectWords, setChosenIncorrectWords] = useState([])
    const [whyInterested, setWhyInterested] = useState('')
    const [grams, setGrams] = useState('')
    const [tenPercent, setTenPercent] = useState('')
    const [oneMeter, setOneMeter] = useState('')
    const [heartBeat, setHeartBeat] = useState('')


    const [hazardEg, setHazardEg] = useState('')
    const [fireSafety, setFireSafety] = useState('')
    const [safetyImportance, setSafetyImportance] = useState('')
    const [oralDiscussion, setOralDiscussion] = useState('')


    const [chosenMethodFill, setChosenMethodFill] = useState('')

    const [chosenPrimaryDocument, setChosenPrimaryDocument] = useState('')


    const [refereeNameOne, setRefereeNameOne] = useState('')
    const [refereeOrgOne, setRefereeOrgOne] = useState('')
    const [refereeContactOne, setRefereeContactOne] = useState('')

    const [refereeNameTwo, setRefereeNameTwo] = useState('')
    const [refereeOrgTwo, setRefereeOrgTwo] = useState('')
    const [refereeContactTwo, setRefereeContactTwo] = useState('')

    // School originals

    const schoolOptions = ['Original Documents', 'Written Statement on School Letterhead', 'Student ID Card']

    const [chosenSchoolDocument, setChosenSchoolDocument] = useState('')

    const originalDocuments = ['Australian Birth Certificate/card (minimum 14 years) issued by the Registrar of Births Deaths and Marriages', 'Australian Citizenship Certificate', 'Current Australian driver’s licence or learner driver’s licence']
    const [originals, setOriginals] = useState([{ number: '', state: '' }, { number: '' }, { number: '', state: '' }])
    const [internationalDocument, setInternationalDocument] = useState('')

    const [letterheadNameSchool, setLetterHeadNameSchool] = useState('')
    const [letterheadNameOfficial, setLetterHeadNameOfficial] = useState('')
    const [letterheadDate, setLetterHeadDate] = useState(format(new Date(), 'dd/MM/yyyy'))

    const [usi, setUsi] = useState('')
    const [title, setTitle] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [otherName, setOtherName] = useState('')

    const [address, setAddress] = useState('')
    const [addressManualFill, setAddressManualFill] = useState(false)
    const [lockAddressManualFields, setLockAddressManualFields] = useState(false)

    const [streetNumber, setStreetNumber] = useState('')
    const [streetName, setStreetName] = useState('')
    const [suburb, setSuburb] = useState('')
    const [state, setState] = useState('')
    const [postcode, setPostcode] = useState('')

    const [postalAddressSame, setPostalAddressSame] = useState(false)

    const [addressPostal, setAddressPostal] = useState('')
    const [addressPostalManualFill, setAddressPostalManualFill] = useState(false)
    const [lockAddressPostalManualFields, setLockAddressPostalManualFields] = useState(false)

    const [streetNumberPostal, setStreetNumberPostal] = useState('')
    const [streetNamePostal, setStreetNamePostal] = useState('')
    const [suburbPostal, setSuburbPostal] = useState('')
    const [statePostal, setStatePostal] = useState('')
    const [postcodePostal, setPostcodePostal] = useState('')


    const [dob, setDob] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [email, setEmail] = useState('')
    const [emailConf, setEmailConf] = useState('')


    const [country, setCountry] = useState('')
    const [otherCountry, setOtherCountry] = useState('')
    const [language, setLanguage] = useState('')
    const [otherLanguage, setOtherLanguage] = useState('')
    const [origin, setOrigin] = useState('')
    const [yearCompleted, setYearCompleted] = useState('')
    const [prevQualification, setPreviousQualification] = useState('')
    const [employment, setEmployment] = useState('')
    const [disabilities, setDisabilities] = useState([])

    const [evidenceIdentity, setEvidenceIdentity] = useState('')

    // School 
    const [passportNumber, setPassportNumber] = useState('')
    const [birthCertificate, setBirthCertificate] = useState('')
    const [birthStateIssue, setBirthStateIssue] = useState('')
    const [citizenCert, setCitizenCert] = useState('')
    const [ausLicense, setAusLicense] = useState('')
    const [ausLicenseStateIssue, setAusLicenseStateIssue] = useState('')
    const [hasStudentIdWithCres, setHasStudentIdWithCres] = useState('')

    // Overseas
    const [passportCountry, setPassportCountry] = useState('')
    const [passportExpiry, setPassportExpiry] = useState('')
    const [arrivalDate, setArrivalDate] = useState('')
    const [drivingLicenseInt, setDrivingLicenseInt] = useState('')
    const [drivingIntCountry, setDrivingIntCountry] = useState('')
    const [nameInstitution, setNameInstitution] = useState('')
    const [institutionExp, setInstitutionExp] = useState('')

    // General
    const [boatLicense, setBoatLicense] = useState('')
    const [boatLicenseStateIssue, setBoatLicenseStateIssue] = useState('')

    const [nswPhotoLicense, setNswPhotoLicense] = useState('')
    const [highRiskLicense, setHighRiskLicense] = useState('')
    const [highRiskLicenseState, setHighRiskLicenseState] = useState('')

    const [proofAgeLicense, setProofAgeLicense] = useState('')
    const [proofAgeLicenseState, setProofAgeLicenseState] = useState('')
    const [policeCard, setPoliceCard] = useState('')

    const [pointsDocuments, setPointsDocuments] = useState([])
    // const [declareHundredPoints, setDeclareHundredPoints] = useState(false)


    const [declarationDate, setDeclarationDate] = useState(format(new Date(), 'dd-MM-yyyy'))
    const [trainerId, setTrainerId] = useState('')
    const [delivery, setDelivery] = useState('')

    const signatureRef = useRef()
    const [pilotError, setPilotError] = useState('')
    const [pilotLoading, setPilotLoading] = useState(Boolean(pilotEnrolmentId()))
    useEffect(() => {
        if (!pilotEnrolmentId()) return;
        pilotRequest('formContext').then(context => {
            if (context.course !== 'white-card-nsw') throw new Error('This form is not for your booked course.');
            setFirstName(context.person.firstName); setLastName(context.person.lastName);
            setStudentName(`${context.person.firstName} ${context.person.lastName}`);
            setEmail(context.person.email); setPhoneNumber(context.person.phoneNumber);
            setDob(context.person.dob.split('-').reverse().join('/'));
            setTrainerId(context.trainerId); setDelivery(context.delivery); setDateFirstPage(new Date(`${context.date}T12:00:00`));
        }).catch(error => setPilotError(error.message)).finally(() => setPilotLoading(false));
    }, [])

    const navigate = useNavigate()

    useEffect(() => {
        const params = getUrlParams()
        if (params.trainerId || params.trainerid) {
            setTrainerId(params.trainerId || params.trainerid)
        } else {
            toast.error('Trainer ID is required!!!', { position: 'top-center' })
            return
        }

        if (params.delivery) {
            setDelivery(params.delivery[0].toUpperCase() + params.delivery.substring(1))
        } else {
            toast.error('Delivery method is required!!!', { position: 'top-center' })
        }
    }, [])

    useEffect(() => {
        if (trainerId) {
            const matchingTrainer = trainers.find(r => r.trainerId === trainerId)
            if (matchingTrainer) {
                setTrainerName(matchingTrainer.name)
            }
        }
    }, [trainerId])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [page])

    useEffect(() => {
        if (postalAddressSame) {
            setStreetNumberPostal(streetNumber)
            setStreetNamePostal(streetName)
            setSuburbPostal(suburb)
            setPostcodePostal(postcode)
            setStatePostal(state)
            setAddressPostal(address)
            setLockAddressPostalManualFields(true)
        }
    }, [postalAddressSame])

    const evidenceOptions = ['Aboriginal and Torres Strait Islanders', 'School sector', 'Overseas persons recently arrived in Australia for less than 6 weeks.']

    const pointsDocumentOptions = ['Credit/Debit card/Statement (1)', 'Credit/Debit card/Statement (2)', 'Current Medicare card', 'Telephone Bill (issued in last 3 months)', 'Utility Bill (issued in last 3 months)', 'Current Centrelink card', 'Current Vehicle Registration', 'Property Lease Agreement', 'Motor Vehicle Insurance', 'Council Rates notice (issued in last 3 months)', 'Home Insurance papers', 'Dept Veterans Affairs card']


    const newFirstPageValidations = [
        // { name: 'usi', value: usi },
        { name: 'studentName', value: studentName },
        { name: 'trainingCourse', value: trainingCourse },
        { name: 'iCan', value: iCan, array: true },

        // { name: 'alphabetWords', value: alphabetWords, array: true },
        { name: 'alphabetWordOne', value: alphabetWordOne },
        { name: 'alphabetWordTwo', value: alphabetWordTwo },
        { name: 'alphabetWordThree', value: alphabetWordThree },
        { name: 'alphabetWordFour', value: alphabetWordFour },
        { name: 'alphabetWordFive', value: alphabetWordFive },
        { name: 'alphabetWordSix', value: alphabetWordSix },
        { name: 'chosenIncorrectWords', value: chosenIncorrectWords, array: true },
        { name: 'whyInterested', value: whyInterested },
        { name: 'grams', value: grams },
        { name: 'tenPercent', value: tenPercent },

        { name: 'oneMeter', value: oneMeter },
        { name: 'heartBeat', value: heartBeat },
        { name: 'hazardEg', value: hazardEg },
        { name: 'fireSafety', value: fireSafety },
        { name: 'safetyImportance', value: safetyImportance },
        // { name: 'oralDiscussion', value: oralDiscussion },
    ]

    const firstPageValidations = [
        // { name: 'usi', value: usi },
        { name: 'title', value: title },
        { name: 'firstName', value: firstName },
        { name: 'lastName', value: lastName },

        { name: 'streetNumber', value: streetNumber },
        { name: 'streetName', value: streetName },
        { name: 'suburb', value: suburb },
        { name: 'state', value: state },
        { name: 'postcode', value: postcode },

        { name: 'streetNumberPostal', value: streetNumberPostal },
        { name: 'streetNamePostal', value: streetNamePostal },
        { name: 'suburbPostal', value: suburbPostal },
        { name: 'statePostal', value: statePostal },
        { name: 'postcodePostal', value: postcodePostal },
        { name: 'dob', value: dob },
        { name: 'phoneNumber', value: phoneNumber },
        { name: 'email', value: email },
        // { name: 'emailConf', value: emailConf },
    ]


    const secondPageValidations = [
        { name: 'country', value: country },
        { name: 'language', value: language },
        { name: 'origin', value: origin },
        { name: 'yearCompleted', value: yearCompleted },
        { name: 'prevQualification', value: prevQualification },
        { name: 'employment', value: employment },
    ]

    const validationOverseas = [
        { name: 'passportNumber', value: passportNumber },
        { name: 'passportCountry', value: passportCountry },
        { name: 'passportExpiry', value: passportExpiry },
        { name: 'arrivalDate', value: arrivalDate },
    ]



    const aborginalRefereeValidations = [
        { name: 'refereeNameOne', value: refereeNameOne },
        { name: 'refereeOrgOne', value: refereeOrgOne },
        { name: 'refereeContactOne', value: refereeContactOne },
        { name: 'refereeNameTwo', value: refereeNameTwo },
        { name: 'refereeOrgTwo', value: refereeOrgTwo },
        { name: 'refereeContactTwo', value: refereeContactTwo },
    ]

    const schoolLetterheadValidations = [
        { name: 'letterheadNameSchool', value: letterheadNameSchool },
        { name: 'letterheadNameOfficial', value: letterheadNameOfficial },
        { name: 'letterheadDate', value: letterheadDate },
    ]

    console.log('pointsDocuments', pointsDocuments)

    const submitForm = async (studentDetailVerification) => {
        let additionalPayload = {}
        const chosenMethod = chosenMethodFill?.value
        const primaryDocument = chosenPrimaryDocument?.value
        const evidenceType = evidenceIdentity?.value
        const schoolDocument = chosenSchoolDocument?.value

        if (chosenMethod === eoiOptions[0]) {
            if (primaryDocument === 'Birth Certificate') {
                additionalPayload = {
                    birthCertificate,
                    birthStateIssue: birthStateIssue?.value,
                }
            } else if (primaryDocument === 'Australian / International Passport') {
                additionalPayload = {
                    passportNumber,
                    passportCountry,
                }

            } else if (primaryDocument === 'Australian Citizenship Certificate') {
                additionalPayload = { citizenCert }
            }

            additionalPayload = {
                chosenPrimaryDocument: primaryDocument || '',
                ...additionalPayload,
                ausLicense,
                ausLicenseStateIssue: ausLicenseStateIssue && ausLicenseStateIssue.value,
                boatLicense,
                boatLicenseStateIssue: boatLicenseStateIssue && boatLicenseStateIssue.value,
                nswPhotoLicense,
                highRiskLicense,
                highRiskLicenseState: highRiskLicenseState?.value || '',
                proofAgeLicense,
                proofAgeLicenseState: proofAgeLicenseState?.value || '',
                policeCard,
                pointsDocuments: pointsDocuments.map(row => row.value),
            }
        } else if (chosenMethod === eoiOptions[1]) {
            if (evidenceType === evidenceOptions[0]) {
                additionalPayload = { refereeNameOne, refereeOrgOne, refereeContactOne, refereeNameTwo, refereeOrgTwo, refereeContactTwo, }
            } else if (evidenceType === evidenceOptions[1]) {
                if (schoolDocument === schoolOptions[0]) {
                    additionalPayload = { originals: originals.map(r => ({ ...r, state: r.state && r.state.value })), internationalDocument }
                } else if (schoolDocument === schoolOptions[1]) {
                    additionalPayload = { letterheadNameSchool, letterheadNameOfficial, letterheadDate }
                }

                additionalPayload = { ...additionalPayload, chosenSchoolDocument: schoolDocument || '' }
            } else if (evidenceType === evidenceOptions[2]) {
                additionalPayload = { passportNumber, passportCountry, passportExpiry, arrivalDate, internationalDocument, drivingLicenseInt, drivingIntCountry, nameInstitution, institutionExp }
            }

            additionalPayload = { ...additionalPayload, evidenceIdentity: evidenceType || '', }
        }

        try {
            setLoading(true)
            showLoadingMessage('Submitting EOI')
            const submitted = await axios.post(pilotFunctionUrl('fillEOIPdfForm'), {
                pilot: pilotSubmission(),
                data: {
                    studentName,
                    trainingCourse,
                    dateFirstPage,
                    iCan,
                    alphabetWords: [alphabetWordOne, alphabetWordTwo, alphabetWordThree, alphabetWordFour, alphabetWordFive, alphabetWordSix],
                    chosenIncorrectWords,
                    whyInterested,
                    grams,
                    tenPercent,
                    oneMeter,
                    heartBeat,
                    hazardEg,
                    fireSafety,
                    safetyImportance,
                    oralDiscussion,
                    trainerId,
                    delivery,
                    chosenMethodFill: chosenMethod || '',
                    ...additionalPayload,
                    title: title.value,
                    firstName,
                    lastName,
                    otherName,
                    email,
                    phoneNumber,
                    dob,
                    address,
                    streetNumber,
                    streetName,
                    postcode,
                    suburb,
                    state: state.value,
                    postalAddressSame,
                    addressPostal,
                    streetNumberPostal,
                    streetNamePostal,
                    postcodePostal,
                    suburbPostal,
                    statePostal: statePostal.value,
                    evidenceIdentity: evidenceType || '',
                    studentDetailVerification,
                    declarationDate,
                    signature: signatureRef.current.getTrimmedCanvas().toDataURL('image/png')
                }
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                }
            })

            setLoading(false)
            setShowDetailConfirmationModal(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
            showSuccessMessage('EOI submitted successfully')
            if (pilotEnrolmentId()) {
                const linked = await pilotAttach('attachEoi', { pdfUrl: submitted.data });
                if (!linked.linked) showWarningMessage(`Your EOI was submitted. ${linked.error} Your trainer can finish linking it - do not submit this form again.`);
                navigate('/student-pilot');
            } else navigate('/thankyou')
        } catch (e) {
            clearPageMessage()
            showWarningMessage(e.response?.data?.error || 'EOI could not be submitted. Please try again.')
            setLoading(false)
            console.error('e', e)
        }
    }

    const handleDetailConfirmationSubmit = async () => {
        const fieldValues = buildStudentDetailFieldValues({
            firstName,
            lastName,
            otherName,
            email,
            dob,
            streetNumber,
            streetName,
            suburb,
            state,
            postcode,
            streetNumberPostal,
            streetNamePostal,
            suburbPostal,
            statePostal,
            postcodePostal,
        })

        const studentDetailVerification = buildStudentDetailVerificationAudit({
            confirmationState: detailConfirmationState,
            fieldValues,
        })

        await submitForm(studentDetailVerification)
    }

    const handleNext = async () => {

        let tempErrors = []
        if (page === 0) {
            newFirstPageValidations.forEach(row => {
                if (row.array) {
                    console.log(row.name, row.value)
                    if (row.value.length === 0 || row.value.filter(r => !r).length > 0) {
                        tempErrors.push(row.name)
                    }
                } else {
                    if (!row.value) {
                        tempErrors.push(row.name)
                    }
                }
            })
            if (tempErrors.length > 0) {
                setErrors(tempErrors)
                setErrorMessage('Please fill all the fields.')
                return
            } else {
                //Additional checks
            }

        } else if (page === 2) {
            if (!chosenMethodFill) {
                setErrors(['chosenMethodFill'])
                setErrorMessage('Choose one option.')
                return
            }
            // Various conditions.

            if (chosenMethodFill.value === eoiOptions[0]) {
                // if (!chosenPrimaryDocument) {
                //     setErrors(['primaryDocument'])
                //     setErrorMessage('Choose one primary document.')
                //     return
                // }

                if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Birth Certificate') {
                    if (!birthCertificate) {
                        setErrors(['birthCertificate'])
                        setErrorMessage('Birth Certificate Number is required.')
                        return
                    } else if (!birthStateIssue || !birthStateIssue.value) {
                        setErrors(['birthStateIssue'])
                        setErrorMessage('Birth State required.')
                        return
                    }
                } else if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian / International Passport') {
                    if (!passportNumber) {
                        setErrors(['passportNumber'])
                        setErrorMessage('Passport Number is required.')
                        return
                    } else if (!passportCountry || !passportCountry) {
                        setErrors(['birthStateIssue'])
                        setErrorMessage('Birth State required.')
                        return
                    }

                } else if (chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian Citizenship Certificate') {
                    if (!citizenCert) {
                        setErrors(['citizenCert'])
                        setErrorMessage('Citizenship Certificate Number is required.')
                        return
                    }
                }

                // Check secondary document details.

                if (!ausLicense && !boatLicense && !nswPhotoLicense && !highRiskLicense && !proofAgeLicense && !policeCard && pointsDocuments.length === 0) {
                    setErrors(['secondaryDoc'])
                    setErrorMessage('Provide atleast one secondary document details.')
                    return
                }

                if (ausLicense && (!ausLicenseStateIssue || !ausLicenseStateIssue.value)) {
                    setErrors(['secondaryDoc'])
                    setErrorMessage('Provide state of issue for secondary documents.')
                    return
                } else if (boatLicense && (!boatLicenseStateIssue || !boatLicenseStateIssue.value)) {
                    setErrors(['secondaryDoc'])
                    setErrorMessage('Provide state of issue for secondary documents.')
                    return
                } else if (highRiskLicense && (!highRiskLicenseState || !highRiskLicenseState.value)) {
                    setErrors(['secondaryDoc'])
                    setErrorMessage('Provide state of issue for secondary documents.')
                    return
                } else if (proofAgeLicense && (!proofAgeLicenseState || !proofAgeLicenseState.value)) {
                    setErrors(['secondaryDoc'])
                    setErrorMessage('Provide state of issue for secondary documents.')
                    return
                }

                if (pointsDocuments.length < 2 && !ausLicense && !boatLicense && !nswPhotoLicense && !highRiskLicense && !proofAgeLicense && !policeCard) {
                    setErrors(['pointsDocuments'])
                    setErrorMessage('Provide minimum of 2 points documents to meet criteria.')
                    return
                }
            } else {
                // Special arrangements section.

                if (!evidenceIdentity) {
                    setErrors(['evidenceIdentity'])
                    setErrorMessage('Choose one option')
                    return

                }

                if (evidenceIdentity.value === evidenceOptions[0]) {
                    aborginalRefereeValidations.forEach(row => {
                        if (!row.value) {
                            tempErrors.push(row.name)
                        }
                    })
                    if (tempErrors.length > 0) {
                        setErrors(tempErrors)
                        setErrorMessage('Please fill all the fields.')
                        return
                    }
                } else if (evidenceIdentity.value === evidenceOptions[1]) {

                    // School sector 

                    if (!chosenSchoolDocument) {
                        setErrors(['chosenSchoolDocument'])
                        setErrorMessage('Please choose a document.')
                        return
                    }

                    if (chosenSchoolDocument.value === schoolOptions[0]) {
                        // If no original or international travel document provided.
                        if (originals.filter(r => !r.number).length == originals.length && !internationalDocument) {
                            setErrors([''])
                            setErrorMessage('Please provide original document information.')
                            return
                        }
                        if (originals[0].number && !originals[0].state) {
                            setErrors([''])
                            setErrorMessage('Please provide state information for original document.')
                            return
                        } else if (originals[2].number && !originals[2].state) {
                            setErrors([''])
                            setErrorMessage('Please provide state information for original document.')
                            return
                        }
                    } else if (chosenSchoolDocument.value === schoolOptions[1]) {
                        schoolLetterheadValidations.forEach(row => {
                            if (!row.value) {
                                tempErrors.push(row.name)
                            }
                        })
                        if (tempErrors.length > 0) {
                            setErrors(tempErrors)
                            setErrorMessage('Please fill all the fields.')
                            return
                        }
                    }

                } else {
                    // Overseas

                    if (internationalDocument) {
                        // International document provided , skip checking passport information.
                    } else {
                        validationOverseas.forEach(row => {
                            if (!row.value) {
                                tempErrors.push(row.name)
                            }
                        })
                        if (tempErrors.length > 0) {
                            setErrors(tempErrors)
                            setErrorMessage('Please fill all the fields.')
                            return
                        }

                        if (passportExpiry && !passportExpiry.match(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/)) {
                            setErrors(['passportExpiry'])
                            setErrorMessage('Please check format of expiry date of passport.')
                            return
                        } else if (passportExpiry && isBefore(new Date(reverseDateString(passportExpiry, true)), new Date())) {
                            setErrors(['passportExpiry'])
                            setErrorMessage('Please check expiry date of passport. It should be in the future.')
                            return
                        } else if (arrivalDate && !arrivalDate.match(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/)) {
                            setErrors(['arrivalDate'])
                            setErrorMessage('Please check arrival date format.')
                            return
                        } else if (arrivalDate && !isBefore(new Date(reverseDateString(arrivalDate, true)), new Date())) {
                            setErrors(['arrivalDate'])
                            setErrorMessage('Please check arrival date. It should be in the past.')
                            return
                        }
                    }

                    if (!drivingLicenseInt && !nameInstitution) {
                        setErrors([''])
                        setErrorMessage('Please provide Current Driving License or  Credit/Savings account card details.')
                        return
                    }

                    if (drivingLicenseInt && !drivingIntCountry) {
                        setErrors(['drivingIntCountry'])
                        setErrorMessage('Please provide country of issue.')
                        return
                    } else if (nameInstitution && !institutionExp) {
                        setErrors(['institutionExp'])
                        setErrorMessage('Please provide expiry date.')
                        return
                    }

                    if (institutionExp && !institutionExp.match(/^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/)) {
                        setErrors(['institutionExp'])
                        setErrorMessage('Please check format of expiry date of institution.')
                        return
                    } else if (institutionExp && isBefore(new Date(reverseDateString(institutionExp, true)), new Date())) {
                        setErrors(['institutionExp'])
                        setErrorMessage('Please check expiry date of institution. It should be in the future.')
                        return
                    }

                }

            }


        } else if (page === 3) {
            firstPageValidations.forEach(row => {
                if (!row.value) {
                    tempErrors.push(row.name)
                }
            })
            if (tempErrors.length > 0) {
                setErrors(tempErrors)
                setErrorMessage('Please fill all the fields.')
                return
            } else {
                if (!postcode.match(/^\d+$/) || postcode.length !== 4) {
                    setErrors(['postcode'])
                    setErrorMessage('Please enter a valid Postcode.')
                    return
                } else if (!postcodePostal.match(/^\d+$/) || postcodePostal.length !== 4) {
                    setErrors(['postcodePostal'])
                    setErrorMessage('Please enter a valid Postcode.')
                    return
                }
                else if (phoneNumber.match(/^[A-Za-z]+$/)) {
                    setErrors(['phoneNumber'])
                    setErrorMessage('Please enter a valid Phone Number. Cannot include alphabets.')
                    return
                }
                // else if (phoneNumber.length < 10) {
                //     setErrors(['phoneNumber'])
                //     setErrorMessage('Please enter a valid Phone Number.')
                //     return
                // } 
                else if (!dob.match(/^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/](19|20)\d\d$/)) {
                    setErrors(['dob'])
                    setErrorMessage('Please enter a valid DOB & match expected format.')
                    return
                } else if (isAfter(new Date(dob.split('-')[2] + '/' + dob.split('-')[1] + '/' + dob.split('-')[0]), new Date())) {
                    setErrors(['dob'])
                    setErrorMessage('Please enter a valid DOB. DOB should be in the past.')
                    return
                } else if (!email.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                    setErrors(['email'])
                    setErrorMessage('Please enter a valid email.')
                    return
                } else if (!declarationDate) {
                    setErrors(['declarationDate'])
                    setErrorMessage('Please enter a valid Declaration Date.')

                    return

                } else if (signatureRef.current.isEmpty()) {
                    setErrors(['signature'])
                    setErrorMessage('Please provide a signature.')
                    return
                }
                // else if (!emailConf.trim().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
                //     setErrors(['emailConf'])
                //     setErrorMessage('Please enter a valid email Confirmation.')
                //     return
                // } else if (emailConf.trim() !== email.trim()) {
                //     setErrors(['emailConf'])
                //     setErrorMessage('Emails don\'t match.')
                //     return
                // }
            }
        }

        setErrorMessage('')
        setErrors([])
        page !== 3 && setPage(page + 1)

        if (page === 3) {
            const fieldValues = buildStudentDetailFieldValues({
                firstName,
                lastName,
                email,
                dob,
                streetNumber,
                streetName,
                suburb,
                state,
                postcode,
                streetNumberPostal,
                streetNamePostal,
                suburbPostal,
                statePostal,
                postcodePostal,
            })
            const nextSnapshot = buildStudentDetailVerificationSnapshot(fieldValues)

            if (detailConfirmationSnapshot !== nextSnapshot) {
                setDetailConfirmationState(createStudentDetailVerificationState())
                setDetailConfirmationSnapshot(nextSnapshot)
            }

            setShowDetailConfirmationModal(true)

        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    const goToPrevPage = () => {
        if (page > 0) {
            setPage(page - 1)
            setErrorMessage('')
            setErrors([])
        }
    }

    const toggleIncorrectWords = (word, value) => {
        if (value && !chosenIncorrectWords.includes(word)) {
            setChosenIncorrectWords([...chosenIncorrectWords, word])
        } else {
            setChosenIncorrectWords(chosenIncorrectWords.filter(r => r !== word))
        }

    }

    if (pilotLoading || pilotError) return <div className='form-wrapper'><h1>Student enrolment</h1><p role={pilotError ? 'alert' : 'status'}>{pilotError || 'Loading your verified profile...'}</p><a href='/student-pilot'>Return to my courses</a></div>;
    return (<div className='form-wrapper'>
        <h1>LLN & Evidence of Identity</h1>

        {page === 0 ? <>
            <Input type={'text'} bold errorMessage={errors.includes('studentName') && errors.length === 1 && errorMessage} errors={errors} name={'studentName'} value={studentName} setValue={setStudentName} label={'Student Name'} />
            <Input type={'text'} bold disabled errorMessage={errors.includes('trainingCourse') && errors.length === 1 && errorMessage} errors={errors} name={'trainingCourse'} value={trainingCourse} setValue={setTrainingCourse} label={'Training Course'} />
            {/* <Input type={'text'} errorMessage={errors.includes('dateFirstPage') && errors.length === 1 && errorMessage} errors={errors} name={'dateFirstPage'} value={dateFirstPage} setValue={setDateFirstPage} label={'Date'} /> */}
            <label style={{ display: 'flex', marginTop: '15px', fontWeight: '800', fontSize: '15px', color: '#000' }}>{'Date'}</label>
            <MyCalendar startDate={dateFirstPage} setStartDate={setDateFirstPage} />
            <Input disabled type={'text'} bold errorMessage={errors.includes('trainerName') && errors.length === 1 && errorMessage} errors={errors} name={'trainerName'} value={trainerName} setValue={setTrainerName} label={'Trainer Name'} />
            <Input disabled type={'text'} bold errorMessage={errors.includes('delivery') && errors.length === 1 && errorMessage} errors={errors} name={'delivery'} value={delivery} setValue={setDelivery} label={'Delivery'} />

            <p>This pre training language, literacy and numeracy assessment is carried out to assess your
                capabilities. As an RTO, we always try to deliver the highest standard of service, and to do this, we
                need to ensure you have the knowledge to complete this training course.</p>
            <p><b>Instructions:<br /></b>
                Complete the following exercises to the best of your ability. You should try to complete all tasks
                and take your time and read each question carefully.</p>
            <p><b>This evaluation is not a test<br /></b>
                The information you provide about your writing and math skills will help us plan support throughout
                the program. This information is confidential and will not be used for any other purpose and will
                remain the property of Upskill Institute.</p>
            <b className={errors.includes('iCan') && 'error'}>Tell us about your reading, writing and numeracy skills.</b>
            <table>
                <thead>
                    <tr>

                        <th>I can</th>
                        <th>Yes</th>
                        <th>Sometimes</th>
                        <th>No</th>
                    </tr>
                </thead>
                <tbody>
                    {iCanLabels.map((label, index) => <tr key={label}>
                        <td>{label}</td>
                        <td> <Radio checked={'Yes' === iCan[index]} label={'Yes'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                        <td> <Radio checked={'Sometimes' === iCan[index]} label={'Sometimes'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                        <td> <Radio checked={'No' === iCan[index]} label={'No'} setValue={v => setICan([...iCan.map((r, idx) => idx === index ? v : r)])} /></td>
                    </tr>)}
                </tbody>
            </table>
            <br />
            <b>1. Look at the group of words below. Arrange these words in alphabetical order</b>

            <p> sun - shop - stop - strong - some - spot</p>
            {/* {alphabetWords.map((word, index) =>
            <Input key={word + index} type={'text'} errors={[]} name={'alphabetWords'} value={word} setValue={v => setAlphabetWords(alphabetWords.map((r, idx) => idx === index ? v : r))} label={index + 1 + '.'} />
            )} */}

            <Input type={'text'} errors={errors} name={'alphabetWordOne'} value={alphabetWordOne} setValue={setAlphabetWordOne} label={1 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordTwo'} value={alphabetWordTwo} setValue={setAlphabetWordTwo} label={2 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordThree'} value={alphabetWordThree} setValue={setAlphabetWordThree} label={3 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordFour'} value={alphabetWordFour} setValue={setAlphabetWordFour} label={4 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordFive'} value={alphabetWordFive} setValue={setAlphabetWordFive} label={5 + '.'} />
            <Input type={'text'} errors={errors} name={'alphabetWordSix'} value={alphabetWordSix} setValue={setAlphabetWordSix} label={6 + '.'} />

            <br />
            <b className={errors.includes('chosenIncorrectWords') && 'error'}>2. Tick each incorrectly spelt words</b>
            <br />
            <br />
            <div className='checkboxGroup' style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {incorrectWords.map(word =>
                    <Checkbox key={word} label={word} value={chosenIncorrectWords.includes(word)} setValue={(v) => toggleIncorrectWords(word, v)} />
                )}
            </div>

            <br />
            <br />
            <b>3. Write a short paragraph about why you are interested in doing this course?</b>
            <br />
            <textarea className={errors.includes('whyInterested') && 'error'} onChange={e => setWhyInterested(e.target.value)} value={whyInterested}></textarea>

            <b>4. How many grams in a kilogram? Tick the correct answer.</b>
            <div style={{ display: 'flex' }} className={'radioGroup ' + (errors.includes('grams') ? 'error' : '')}>
                {['100', '900', '1,000', '1,200'].map(word =>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                        <Radio checked={grams === word} label={word} setValue={setGrams} />
                        <label style={{ marginTop: '5px' }}>{word}</label>
                    </div>
                )}
            </div>
            <br />
            <b>5. If 10% of a number is 100, what is the number? Tick the correct answer.</b>
            <div style={{ display: 'flex' }} className={'radioGroup ' + (errors.includes('tenPercent') ? 'error' : '')}>
                {['10', '100', '1,000', '10,000'].map(word =>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                        <Radio checked={tenPercent === word} label={word} setValue={setTenPercent} />
                        <label style={{ marginTop: '5px' }}>{word}</label>
                    </div>
                )}
            </div>

            <br />
            <b>6. One (1) metre (m) is equal to how many centimetres? Tick the correct answer</b>
            <div style={{ display: 'flex' }} className={'radioGroup ' + (errors.includes('oneMeter') ? 'error' : '')}>
                {['10,000', '1,000', '100', '10',].map(word =>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                        <Radio checked={oneMeter === word} label={word} setValue={setOneMeter} />
                        <label style={{ marginTop: '5px' }}>{word}</label>
                    </div>
                )}
            </div>


            <br />
            <b>7. Calculate the heart beats per minute if a patient’s heart beats at 10 beats every 10 seconds. Tick the correct answer</b>
            <div style={{ display: 'flex' }} className={'radioGroup ' + (errors.includes('heartBeat') ? 'error' : '')}>
                {['20', '60', '100', '120',].map(word =>
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
                        <Radio checked={heartBeat === word} label={word} setValue={setHeartBeat} />
                        <label style={{ marginTop: '5px' }}>{word}</label>
                    </div>
                )}
            </div>

            <br />
            <b>8. What are two examples of a hazard on a construction site?</b>
            <br />
            <textarea className={errors.includes('hazardEg') && 'error'} onChange={e => setHazardEg(e.target.value)} value={hazardEg}></textarea>

            <br />
            <b>9. What types of fire safety equipment are you familiar with?</b>
            <br />
            <textarea className={errors.includes('fireSafety') && 'error'} onChange={e => setFireSafety(e.target.value)} value={fireSafety}></textarea>

            <br />
            <b>10. Why do you think safety is important when working on a construction site?</b>
            <br />
            <textarea className={errors.includes('safetyImportance') && 'error'} onChange={e => setSafetyImportance(e.target.value)} value={safetyImportance}></textarea>

            <br />
            <b>11. Oral Discussion</b>
            <p>Describe what you see in this picture below to your assessor. The Assessor will record your
                response below</p>
            <img src='https://upskillinstitute.com.au/docs/Oral-Discussion.jpg' style={{ width: '100%' }} />
            <textarea className={errors.includes('oralDiscussion') && 'error'} onChange={e => setOralDiscussion(e.target.value)} value={oralDiscussion}></textarea>


        </> :
            page === 1 ? <>

                <img src={Page1} style={{ width: '100%' }} />
            </> :
                page === 2 ? <>
                    <h4>IMPORTANT</h4>
                    <p>You must complete the evidence of identity check for this course. Please select one of the below.</p>

                    <Dropdown options={eoiOptions} value={chosenMethodFill} setValue={setChosenMethodFill} label={''} errorFields={errors} name={'chosenMethodFill'} />

                    {chosenMethodFill && chosenMethodFill.value === eoiOptions[0] ? <>
                        <br />
                        <b>Primary (only use one primary document)</b>

                        <Dropdown options={['Birth Certificate', 'Australian / International Passport', 'Australian Citizenship Certificate']} value={chosenPrimaryDocument} setValue={setChosenPrimaryDocument} label={'Choose Primary Document'} errorFields={errors} name={'primaryDocument'} />


                        {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Birth Certificate' && <>
                            <Input bold type={'text'} errorMessage={errors.includes('birthCertificate') && errors.length === 1 && errorMessage} errors={errors} name={'birthCertificate'} value={birthCertificate} setValue={setBirthCertificate} label={'Australian Birth Certificate Number (70 points)'} />
                            <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={birthStateIssue} setValue={setBirthStateIssue} label={'State of Issue'} errorFields={errors} name={'birthStateIssue'} />
                        </>}


                        {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian / International Passport' && <>
                            <Input bold type={'text'} errorMessage={errors.includes('passportNumber') && errors.length === 1 && errorMessage} errors={errors} name={'passportNumber'} value={passportNumber} setValue={setPassportNumber} label={'Passport Number (70 points)'} />
                            <Input bold type={'text'} errorMessage={errors.includes('passportCountry') && errors.length === 1 && errorMessage} errors={errors} name={'passportCountry'} value={passportCountry} setValue={setPassportCountry} label={'Country of Issue'} />
                        </>}

                        {chosenPrimaryDocument && chosenPrimaryDocument.value === 'Australian Citizenship Certificate' && <>
                            <Input bold type={'text'} errorMessage={errors.includes('citizenCert') && errors.length === 1 && errorMessage} errors={errors} name={'citizenCert'} value={citizenCert} setValue={setCitizenCert} label={'Australian Citizenship Certificate Number (70 points)'} />
                        </>}


                        <hr />

                        <b className={errors.includes('secondaryDoc') && 'error'}>Secondary</b>

                        <br />
                        <br />
                        <br />

                        <table className='flip-vertical-table'>

                            <tbody>
                                <tr>
                                    <td>Current Australian driver\'s licence or learner driver\'s licence (40 Points)</td>
                                    <td style={{ width: '160px' }}>
                                        <Input bold type={'text'} errorMessage={errors.includes('ausLicense') && errors.length === 1 && errorMessage} errors={errors} name={'ausLicense'} value={ausLicense} setValue={setAusLicense} label={'Number'} />
                                    </td>
                                    <td style={{ width: '120px' }}>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={ausLicenseStateIssue} setValue={setAusLicenseStateIssue} label={'State of Issue'} errorFields={errors} name={'ausLicenseStateIssue'} />
                                    </td>
                                </tr>


                                <tr>
                                    <td>Current Australian Boat or PWC Licence (40 Points) </td>
                                    <td>
                                        <Input bold type={'text'} errorMessage={errors.includes('boatLicense') && errors.length === 1 && errorMessage} errors={errors} name={'boatLicense'} value={boatLicense} setValue={setBoatLicense} label={'Number'} />
                                    </td>
                                    <td>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={boatLicenseStateIssue} setValue={setBoatLicenseStateIssue} label={'State of Issue'} errorFields={errors} name={'boatLicenseStateIssue'} />
                                    </td>
                                </tr>

                                <tr>
                                    <td>Current NSW Firearms Photo Licence (40 Points) </td>
                                    <td>
                                        <Input bold type={'text'} errorMessage={errors.includes('nswPhotoLicense') && errors.length === 1 && errorMessage} errors={errors} name={'nswPhotoLicense'} value={nswPhotoLicense} setValue={setNswPhotoLicense} label={'Number'} />
                                    </td>
                                    <td>
                                    </td>
                                </tr>


                                <tr>
                                    <td>Current Australian High Risk Work Licence (40 Points)</td>
                                    <td>
                                        <Input bold type={'text'} errorMessage={errors.includes('highRiskLicense') && errors.length === 1 && errorMessage} errors={errors} name={'highRiskLicense'} value={highRiskLicense} setValue={setHighRiskLicense} label={'Number'} />

                                    </td>
                                    <td>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={highRiskLicenseState} setValue={setHighRiskLicenseState} label={'State of Issue'} errorFields={errors} name={'highRiskLicenseState'} />
                                    </td>
                                </tr>


                                <tr>
                                    <td>Current Australian Proof of Age or Photo Card - RMS Issued (40 Points)</td>
                                    <td>
                                        <Input bold type={'text'} errorMessage={errors.includes('proofAgeLicense') && errors.length === 1 && errorMessage} errors={errors} name={'proofAgeLicense'} value={proofAgeLicense} setValue={setProofAgeLicense} label={'Number'} />
                                    </td>
                                    <td>
                                        <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={proofAgeLicenseState} setValue={setProofAgeLicenseState} label={'State of Issue'} errorFields={errors} name={'proofAgeLicenseState'} />
                                    </td>
                                </tr>

                                <tr>
                                    <td>Australian Police or Dept of Defence card with photo (40 Points) </td>
                                    <td>
                                        <Input bold type={'text'} errorMessage={errors.includes('policeCard') && errors.length === 1 && errorMessage} errors={errors} name={'policeCard'} value={policeCard} setValue={setPoliceCard} label={'Number'} />

                                    </td>
                                    <td>
                                    </td>
                                </tr>
                            </tbody>
                        </table>


                        <p style={{ fontWeight: '700', marginTop: '20px' }}>The following documents are worth 25 points.</p>

                        <Dropdown options={pointsDocumentOptions} isMulti value={pointsDocuments} setValue={setPointsDocuments} label={'You can select multiple documents'} errorFields={errors} name={'pointsDocuments'} />
                        <br />
                        <b>Note: If using credit/savings cards or statements (up to a maximum of 2), these must be from different
                            financial institutions. 1 credit/savings card or statement equates to 25 points, 2 equals 50 points. </b>

                    </> : chosenMethodFill && chosenMethodFill.value === eoiOptions[1] && <>
                        <br />
                        <br />
                        <b>Special arrangements apply for participants in the following groups:</b>

                        <ul>
                            <li> Aboriginal and Torres Strait Islanders (part A).</li>
                            <li> School sector (part B).</li>
                            <li> Overseas persons recently arrived in Australia (for less than six weeks) (part C).</li>
                        </ul>

                        <b>In addition, special exception to the EOI requirements may apply to ‘persons at risk’. Such exception will be dealt with on a case-by-case basis by contacting SafeWork NSW on 13 10 50.</b>
                        <br />
                        <br />
                        <b>All EOI documentation provided under special arrangements must be original. The RTO must ensure the appropriate part is filled out and that the participant details and declarations in Section 3 of this form are completed.</b>


                        <Dropdown options={evidenceOptions} value={evidenceIdentity} setValue={setEvidenceIdentity} label={'Please Select ONE of the following'} errorFields={errors} name={'evidenceIdentity'} />

                        {evidenceIdentity && evidenceIdentity.value === evidenceOptions[0] ? <>
                            <p> Authorised referees for Aboriginal and Torres Strait Islanders include:</p>
                            <ul>
                                <li> Chairperson, secretary or CEO of an incorporated Indigenous organisation (including land councils, community councils, housing organisations etc).</li>
                                <li> Community development employment projects coordinator.</li>
                                <li>  School principal.</li>
                                <li>  School counsellor.</li>
                                <li>  Minister of religion.</li>
                                <li> Treating health professional or manager in Aboriginal medical services.</li>
                                <li>  Centrelink staff, Centrelink agent or other government employee of at least five years.</li>
                            </ul>
                            Please attach two written statements on organisational/company letterhead verifying the person’s identification:
                            <br />
                            <br />
                            <b>Referee 1</b>
                            <hr style={{ marginTop: 0 }} />
                            <Input bold type={'text'} errorMessage={errors.includes('refereeNameOne') && errors.length === 1 && errorMessage} errors={errors} name={'refereeNameOne'} value={refereeNameOne} setValue={setRefereeNameOne} label={'Referee Name'} />
                            <Input bold type={'text'} errorMessage={errors.includes('refereeOrgOne') && errors.length === 1 && errorMessage} errors={errors} name={'refereeOrgOne'} value={refereeOrgOne} setValue={setRefereeOrgOne} label={'Referee Organisation'} />
                            <Input bold type={'text'} errorMessage={errors.includes('refereeContactOne') && errors.length === 1 && errorMessage} errors={errors} name={'refereeContactOne'} value={refereeContactOne} setValue={setRefereeContactOne} label={'Referee Contact No'} />

                            <br />
                            <br />
                            <b>Referee 2</b>
                            <hr style={{ marginTop: 0 }} />
                            <Input bold type={'text'} errorMessage={errors.includes('refereeNameTwo') && errors.length === 1 && errorMessage} errors={errors} name={'refereeNameTwo'} value={refereeNameTwo} setValue={setRefereeNameTwo} label={'Referee Name'} />
                            <Input bold type={'text'} errorMessage={errors.includes('refereeOrgTwo') && errors.length === 1 && errorMessage} errors={errors} name={'refereeOrgTwo'} value={refereeOrgTwo} setValue={setRefereeOrgTwo} label={'Referee Organisation'} />
                            <Input bold type={'text'} errorMessage={errors.includes('refereeContactTwo') && errors.length === 1 && errorMessage} errors={errors} name={'refereeContactTwo'} value={refereeContactTwo} setValue={setRefereeContactTwo} label={'Referee Contact No'} />

                        </> : evidenceIdentity && evidenceIdentity.value === evidenceOptions[1] ? <>



                            <Dropdown options={schoolOptions} value={chosenSchoolDocument} setValue={setChosenSchoolDocument} label={'Please Select a type of document'} errorFields={errors} name={'chosenSchoolDocument'} />


                            {chosenSchoolDocument && chosenSchoolDocument.value === schoolOptions[0] ? <>
                                <p>The identity of the student has been verified by sighting any one of the original documents listed below: </p>

                                <table className='flip-vertical-table'>

                                    <tbody>
                                        {originalDocuments.map((doc, index) => <tr key={doc}>
                                            <td>{doc}</td>
                                            <td style={{ width: '160px' }}>
                                                <Input bold type={'text'} errorMessage={errors.includes(doc + ' number') && errors.length === 1 && errorMessage} errors={errors} name={doc + ' number'} value={originals[index].number} setValue={v => setOriginals(originals.map((r, idx) => idx === index ? ({ ...r, number: v }) : r))} label={'Number'} />
                                            </td>
                                            <td style={{ width: '120px' }}>
                                                {index !== 1 && <Dropdown options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={originals[index].state} setValue={v => setOriginals(originals.map((r, idx) => idx === index ? ({ ...r, state: v }) : r))} label={'State'} errorFields={errors} name={doc + ' state'} />}
                                            </td>
                                        </tr>)}
                                    </tbody>
                                </table>

                                <p>International travel documents including a current passport or a passport which has expired within the
                                    last two years, but has not been cancelled. Please state type of travel document (for example – where a
                                    passport is used, include passport number and the country of issue and check the expiry date).</p>

                                <Input bold type={'text'} errorMessage={errors.includes('internationalDocument') && errors.length === 1 && errorMessage} errors={errors} name={'internationalDocument'} value={internationalDocument} setValue={setInternationalDocument} label={''} />



                            </> :

                                chosenSchoolDocument && chosenSchoolDocument.value === schoolOptions[1] ? <>
                                    <p>The identity of the student has been verified by sighting a written statement on school letterhead
                                        confirming the student’s name and date of birth.</p>
                                    <Input bold type={'text'} errorMessage={errors.includes('letterheadNameSchool') && errors.length === 1 && errorMessage} errors={errors} name={'letterheadNameSchool'} value={letterheadNameSchool} setValue={setLetterHeadNameSchool} label={'Name of School and Location'} />
                                    <Input bold type={'text'} errorMessage={errors.includes('letterheadNameOfficial') && errors.length === 1 && errorMessage} errors={errors} name={'letterheadNameOfficial'} value={letterheadNameOfficial} setValue={setLetterHeadNameOfficial} label={'Name and title of School Official'} />
                                    <Input bold type={'text'} errorMessage={errors.includes('letterheadDate') && errors.length === 1 && errorMessage} errors={errors} name={'letterheadDate'} value={letterheadDate} setValue={setLetterHeadDate} label={'Date of statement'} />


                                </> : <>

                                    <p>The identity of the student has been verified by sighting a student ID card that contains the school crest/seal, photo, student’s name and date of birth.</p>

                                </>}


                        </> : evidenceIdentity && evidenceIdentity.value === evidenceOptions[2] && <>
                            <p>Only use this section when the person has been in Australia for less than six weeks and is not ordinarily a resident of Australia. </p>

                            <p>
                                1. The identity of the person has been verified by sighting one of the following overseas travel documents.</p>
                            <Input bold type={'text'} errorMessage={errors.includes('passportNumber') && errors.length === 1 && errorMessage} errors={errors} name={'passportNumber'} value={passportNumber} setValue={setPassportNumber} label={'Passport Number'} />
                            <Input bold type={'text'} errorMessage={errors.includes('passportCountry') && errors.length === 1 && errorMessage} errors={errors} name={'passportCountry'} value={passportCountry} setValue={setPassportCountry} label={'Country'} />
                            <Input bold type={'text'} errorMessage={errors.includes('passportExpiry') && errors.length === 1 && errorMessage} placeholder={'DD-MM-YYYY'} errors={errors} name={'passportExpiry'} value={passportExpiry} setValue={setPassportExpiry} label={'Passport Expiry Date'} />
                            <Input bold type={'text'} errorMessage={errors.includes('arrivalDate') && errors.length === 1 && errorMessage} placeholder={'DD-MM-YYYY'} errors={errors} name={'arrivalDate'} value={arrivalDate} setValue={setArrivalDate} label={'Date of Arrival in Australia '} />

                            <b>OR</b>

                            <p>Other international documents of identity that have the same characteristics as a passport for example – diplomatic documents and documents issued to refugees.</p>

                            <Input bold type={'text'} errorMessage={errors.includes('internationalDocument') && errors.length === 1 && errorMessage} placeholder={''} errors={errors} name={'internationalDocument'} value={internationalDocument} setValue={setInternationalDocument} label={'International Document'} />

                            <b>AND</b>

                            <p>2. Please select only ONE (1) of the following documents and complete the details required</p>

                            <table className='flip-vertical-table'>

                                <tbody>
                                    <tr>
                                        <td>Current Driving Licence</td>
                                        <td>  <Input bold type={'text'} errorMessage={errors.includes('drivingLicenseInt') && errors.length === 1 && errorMessage} errors={errors} name={'drivingLicenseInt'} value={drivingLicenseInt} setValue={setDrivingLicenseInt} label={'Drivers Licence Number'} /></td>
                                        <td> <Input bold type={'text'} errorMessage={errors.includes('drivingIntCountry') && errors.length === 1 && errorMessage} errors={errors} name={'drivingIntCountry'} value={drivingIntCountry} setValue={setDrivingIntCountry} label={'Country of Issue'} /></td>
                                    </tr>
                                    <tr>
                                        <td>Credit/Savings Account Card</td>
                                        <td> <Input bold type={'text'} errorMessage={errors.includes('nameInstitution') && errors.length === 1 && errorMessage} errors={errors} name={'nameInstitution'} value={nameInstitution} setValue={setNameInstitution} label={'Name of Bank or Institution'} /></td>
                                        <td> <Input bold type={'text'} placeholder={'DD-MM-YYYY'} errorMessage={errors.includes('institutionExp') && errors.length === 1 && errorMessage} errors={errors} name={'institutionExp'} value={institutionExp} setValue={setInstitutionExp} label={'Expiry Date'} /></td>
                                    </tr>
                                </tbody>
                            </table>

                        </>}

                    </>}


                </> :
                    page === 3 && <>

                        <Dropdown options={['Mr', 'Mrs', 'Ms', 'Miss', 'Other']} value={title} setValue={setTitle} label={'Title'} errorFields={errors} name={'title'} />

                        <label className='fieldHeading'>Full Name as it appears on ID</label>
                        <div className='flexrow'>
                            <Input type={'text'} errorMessage={errors.includes('firstName') && errors.length === 1 && errorMessage} errors={errors} name={'firstName'} value={firstName} setValue={setFirstName} label={'First Name'} />
                            <Input type={'text'} errorMessage={errors.includes('lastName') && errors.length === 1 && errorMessage} errors={errors} name={'lastName'} value={lastName} setValue={setLastName} label={'Last Name'} />
                        </div>
                        <Input type={'text'} errorMessage={errors.includes('otherName') && errors.length === 1 && errorMessage} errors={errors} name={'otherName'} value={otherName} setValue={setOtherName} label={'Other Name (Middle Name)'} />



                        <label className='fieldHeading'> Residential Address</label>

                        <AddressSearch errorMessage={errors.includes('address') && errors.length === 1 && errorMessage} errors={errors} value={address} setValue={setAddress} lockAddressManualFields={lockAddressManualFields} setLockAddressManualFields={setLockAddressManualFields} setAddressManualFill={setAddressManualFill} addressManualFill={addressManualFill} setStreetNumber={setStreetNumber} setStreetName={setStreetName} setSuburb={setSuburb} setState={setState} setPostcode={setPostcode} />
                        {addressManualFill && <>
                            <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('streetNumber') && errors.length === 1 && errorMessage} errors={errors} name={'streetNumber'} value={streetNumber} setValue={setStreetNumber} label={'Unit number/Street number/Property number'} />
                            <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('streetName') && errors.length === 1 && errorMessage} errors={errors} name={'streetName'} value={streetName} setValue={setStreetName} label={'Street Name'} />

                            <div className='flexrow'>
                                <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('suburb') && errors.length === 1 && errorMessage} errors={errors} name={'suburb'} value={suburb} setValue={setSuburb} label={'Suburb'} />
                                <div>
                                    <Dropdown disabled={lockAddressManualFields} options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={state} setValue={setState} label={'State'} errorFields={errors} name={'state'} />
                                </div>

                            </div>

                            <Input disabled={lockAddressManualFields} type={'text'} errorMessage={errors.includes('postcode') && errors.length === 1 && errorMessage} errors={errors} name={'postcode'} value={postcode} setValue={setPostcode} label={'Postcode'} />
                            {lockAddressManualFields && <label>Chose wrong address? <span style={{ textDecorationLine: 'underline' }} onClick={() => { setAddressManualFill(false); setLockAddressManualFields(false) }}>Enter again.</span></label>}

                        </>}



                        <label className='fieldHeading'> Postal Address</label>

                        <Checkbox disabled={!streetName || !suburb || !postcode} label={'Same as residential address'} value={postalAddressSame} setValue={setPostalAddressSame} />
                        {!postalAddressSame && <AddressSearch errorMessage={errors.includes('address') && errors.length === 1 && errorMessage} errors={errors} value={addressPostal} setValue={setAddressPostal} lockAddressManualFields={lockAddressPostalManualFields} setLockAddressManualFields={setLockAddressPostalManualFields} setAddressManualFill={setAddressPostalManualFill} addressManualFill={addressPostalManualFill} setStreetNumber={setStreetNumberPostal} setStreetName={setStreetNamePostal} setSuburb={setSuburbPostal} setState={setStatePostal} setPostcode={setPostcodePostal} />}

                        {(addressPostalManualFill || postalAddressSame) && <>
                            <Input disabled={lockAddressPostalManualFields} type={'text'} errorMessage={errors.includes('streetNumberPostal') && errors.length === 1 && errorMessage} errors={errors} name={'streetNumberPostal'} value={streetNumberPostal} setValue={setStreetNumberPostal} label={'Unit number/Street number/Property number'} />
                            <Input disabled={lockAddressPostalManualFields} type={'text'} errorMessage={errors.includes('streetNamePostal') && errors.length === 1 && errorMessage} errors={errors} name={'streetNamePostal'} value={streetNamePostal} setValue={setStreetNamePostal} label={'Street Name'} />

                            <div className='flexrow'>
                                <Input type={'text'} disabled={lockAddressPostalManualFields} errorMessage={errors.includes('suburbPostal') && errors.length === 1 && errorMessage} errors={errors} name={'suburbPostal'} value={suburbPostal} setValue={setSuburbPostal} label={'Suburb'} />
                                {/* <Input type={'text'} errorMessage={errors.includes('statePostal') && errors.length === 1 && errorMessage} errors={errors} name={'statePostal'} value={statePostal} setValue={setStatePostal} label={'State'} /> */}
                                <div>
                                    <Dropdown disabled={lockAddressPostalManualFields} options={['NSW', 'QLD', 'ACT', 'SA', 'NT', 'VIC', 'TAS', 'WA']} value={statePostal} setValue={setStatePostal} label={'State'} errorFields={errors} name={'statePostal'} />
                                </div>
                            </div>

                            <Input type={'text'} disabled={lockAddressPostalManualFields} errorMessage={errors.includes('postcodePostal') && errors.length === 1 && errorMessage} errors={errors} name={'postcodePostal'} value={postcodePostal} setValue={setPostcodePostal} label={'Postcode'} />
                            {lockAddressPostalManualFields && <label>Chose wrong address? <span style={{ textDecorationLine: 'underline' }} onClick={() => { setAddressPostalManualFill(false); setLockAddressPostalManualFields(false) }}>Enter again.</span></label>}

                        </>}


                        <Input type={'text'} errorMessage={errors.includes('dob') && errors.length === 1 && errorMessage} errors={errors} placeholder={'DD/MM/YYYY'} name={'dob'} value={dob} setValue={setDob} label={'Date of Birth (dd/mm/yyyy)'} />

                        <Input type={'tel'} errorMessage={errors.includes('phoneNumber') && errors.length === 1 && errorMessage} errors={errors} name={'phoneNumber'} value={phoneNumber} setValue={setPhoneNumber} label={'Phone Number'} placeholder={'04XXXXXXXX'} />

                        <Input type={'text'} errorMessage={errors.includes('email') && errors.length === 1 && errorMessage} errors={errors} name={'email'} value={email} setValue={setEmail} label={'Email'} />

                        {/* <Input type={'text'} preventPaste errorMessage={errors.includes('emailConf') && errors.length === 1 && errorMessage} errors={errors} name={'emailConf'} value={emailConf} setValue={setEmailConf} label={'Repeat Email'} /> */}


                        <h3>Participant Declaration</h3>
                        <p> I declare that the details contained on this form are true and correct. The EOI details were provided to the RTO prior to attending GIT under the WHS Regulation.</p>

                        <b>Participant's signature</b>
                        <br />
                        <br />
                        <SignatureCanvas penColor='black'
                            ref={signatureRef}
                            canvasProps={{ width: 500, height: 200, className: `sigCanvas ${errors.includes('signature') ? 'error' : ''}` }} />

                        <p>It is an offence under the Crimes Act 1900 (Crimes Act) and WHS Regulation to make false or misleading
                            statements in this application.</p>
                        <div>
                            <button style={{ color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} onClick={() => signatureRef.current.clear()}>Clear</button>
                        </div>
                        {/* <h3> Date of Declaration </h3> */}
                        <Input bold type={'text'} placeholder={'DD-MM-YYYY'} errorMessage={errors.includes('declarationDate') && errors.length === 1 && errorMessage} errors={errors} name={'declarationDate'} value={declarationDate} disabled setValue={setDeclarationDate} label={'Date of Declaration'} />

                    </>
        }

        {errorMessage && errors.length > 0 && <p style={{ color: 'red', textAlign: 'center' }}>{errorMessage}</p>}

        <div style={{ display: 'flex', alignItems: 'center' }}>
            {page !== 0 && <button style={{ marginLeft: 'auto', display: 'flex', color: '#FF7100', background: 'white', border: '1px solid #FF7100' }} disabled={page === 0 || loading} onClick={goToPrevPage}>Back</button>}
            <button style={{ marginLeft: page === 0 ? 'auto' : '20px', display: 'flex' }} disabled={loading} onClick={handleNext}>{loading ? 'Loading...' : 'Next'}</button>
        </div>

        <StudentDetailConfirmationModal
            showModal={showDetailConfirmationModal}
            setShowModal={setShowDetailConfirmationModal}
            confirmationState={detailConfirmationState}
            setConfirmationState={setDetailConfirmationState}
            fieldValues={buildStudentDetailFieldValues({
                firstName,
                lastName,
                email,
                dob,
                streetNumber,
                streetName,
                suburb,
                state,
                postcode,
                streetNumberPostal,
                streetNamePostal,
                suburbPostal,
                statePostal,
                postcodePostal,
            })}
            onSubmit={handleDetailConfirmationSubmit}
            loading={loading}
        />

    </div >)
}

export default Home
